export default class SegmentRule {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/segment/segment-rule.html'),
            scope: {
                rule: '=',
                campaigns: '=',
                automations: '=',
                daysLimit: '=',
                journeys: '=',

                rulesList: '=',

                subscriberGroups: '=',
                groups: '=',
                operatorGroups: '=',
                autofocus: '=',
                index: '='
            },
            controller: RuleController,
            controllerAs: 'ctrl'
        }
    }
};

class RuleController {
    constructor($scope, $element, $filter, segmentRepo, $timeout) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.links = [];
        this.noLinks = false;
        this.dispatchers = [];
        this.segmentRepo = segmentRepo;
        this.index = $scope.index;
        this.autofocus = $scope.autofocus;

        this.subscriberGroups = $scope.subscriberGroups;
        this.groups = $scope.groups;
        this.operatorGroups = $scope.operatorGroups;

        this.defaultDaysLimit = 30;

        this.dispatcher_types = [
            {
                id: "campaign",
                groupName: $filter('translate')('SEGMENTATION:SHOW:SENDOUTS_NAME'),
                name: $filter('translate')('SEGMENTATION:DISPATCHER_TYPE:CAMPAIGN'),
                basedOn: 'send_outs'
            },
            {
                id: "automation",
                groupName: $filter('translate')('SEGMENTATION:SHOW:SENDOUTS_NAME'),
                name: $filter('translate')('SEGMENTATION:DISPATCHER_TYPE:AUTOMATION'),
                basedOn: 'send_outs'
            },
            {
                id: "journey",
                groupName: $filter('translate')('SEGMENTATION:SHOW:SENDOUTS_NAME'),
                name: $filter('translate')('SEGMENTATION:DISPATCHER_TYPE:JOURNEY'),
                basedOn: 'send_outs'
            }
        ];

        let dispatchersWatcher = $scope.$watchGroup(['campaigns', 'automations'], (newVal, OldVal) => {
            if (this.$scope.rule.rule_type === 'statistic_rule') {
                this.getDispatchers(this.$scope.rule.value.dispatcher_type);
            }
        });

        let groupsWatcher = $scope.$watch(['groups'], () => {
            if (this.$scope.autofocus) {
                setTimeout(() => {
                    angular.element(`#rule-select-${this.$scope.index}`).scope().$select.activate();
                    delete this.$scope.rule.autofocus;
                }, 1000)
            }
        });

        this.dispatchersListLength = this.initialDispatcherListLength = 10;
        this.dispatcherLoadlistIncrement = 10;

        if (this.$scope.rule.rule_type === 'statistic_rule') {

            this.$scope.rule.value.days_limit = this.$scope.rule.value.days_limit || this.defaultDaysLimit;

            this.getDispatchers($scope.rule.value.dispatcher_type);

            this.updateStatisticTypes();
            if (this.isSMS($scope.rule.value.dispatcher)) {
                this.setStatisticTypesForSMS();
            }
        }

        $scope.$on('$destroy', () => {
            dispatchersWatcher();
            groupsWatcher();
        });

        this.updateLastSelection();
    }

    getDispatchers(dispatcherType) {

        if (dispatcherType === this.dispatcher_types[0].id) {
            this.dispatchers = angular.copy(this.$scope.campaigns);
            this.dispatchers.unshift({
                name: this.$filter('translate')('SEGMENTATION:LAST_X_CAMPAIGNS').replace('?', 10),
                last_dispatchers_count: 10
            });
            this.dispatchers.unshift({
                name: this.$filter('translate')('SEGMENTATION:LAST_X_CAMPAIGNS').replace('?', 5),
                last_dispatchers_count: 5
            });
            this.dispatchers.unshift({
                name: this.$filter('translate')('SEGMENTATION:LAST_CAMPAIGN'),
                last_dispatchers_count: 1
            });
            this.dispatchers.unshift({name: this.$filter('translate')('SEGMENTATION:ALL_CAMPAIGNS')});
        }
        if (dispatcherType === this.dispatcher_types[1].id) {
            this.dispatchers = this.$scope.automations;
        }
        if (dispatcherType === this.dispatcher_types[2].id) {
            this.dispatchers = this.$scope.journeys;
        }

        this.getLinks();
    }

    getLinks() {
        this.links = [];
        this.noLinks = false;
        let dispatcherId = this.$scope.rule.value.dispatcher;
        let dispatcherType = this.$scope.rule.value.dispatcher_type;
        if (Number.isInteger(dispatcherId) && dispatcherId >= 0 && this.statisticTypeIsLink() && ['campaign', 'journey'].includes(dispatcherType)) {
            this.segmentRepo.getDispatcherLinks(dispatcherType, dispatcherId).then((res) => {
                this.links = res.data;
                if (!this.links.length) {
                    return this.noLinks = true;
                }
                this.noLinks = false;
            });
        }
    }

    onDispatcherSelect($item) {
        this.$scope.rule.statistic_type = null;
        this.$scope.rule.value.link = null;
        this.$scope.rule.value.last_dispatchers_count = $item ? $item.last_dispatchers_count : null;
        this.updateStatisticTypes();
        if ($item && $item.message_type_id === 2) {
            this.statistic_types = this.setStatisticTypesForSMS();
            this.$scope.rule.statistic_type = 3;
        }
        this.getLinks();
    }

    onItemSelected($item) {
        if (this.lastSelection !== undefined && [$item.id, $item.fieldId].indexOf(this.lastSelection) !== -1) {
            return;
        }

        this.transformRule($item);
        this.updateLastSelection();
    }

    onDispatcherTypeChange($item) {
        this.$scope.rule.value.dispatcher = null;
        this.$scope.rule.statistic_type = null;
        this.$scope.rule.value.link = null;
        this.updateStatisticTypes();
        this.getDispatchers($item.id);
    }

    onStatisticTypeSelect($item) {
        if (this.statisticTypeIsLink()) {
            this.getLinks();
        } else {
            this.$scope.rule.value.link = null;
        }
    }

    statisticTypeIsLink() {
        return this.$scope.rule.statistic_type === 3;
    }

    setStatisticTypesForSMS() {
        return this.statistic_types = [
            {value: 'link', id: 3, name: this.$filter('translate')('SEGMENTATION:STATISTIC_TYPE:LINK')},
            {value: 'received', id: 6, name: this.$filter('translate')('SEGMENTATION:STATISTIC_TYPE:RECEIVED')},
        ]
    }

    updateStatisticTypes() {
        return this.statistic_types = [
            {value: 'open', id: 1, name: this.$filter('translate')('SEGMENTATION:STATISTIC_TYPE:OPEN')},
            {value: 'link', id: 3, name: this.$filter('translate')('SEGMENTATION:STATISTIC_TYPE:LINK')},
            {value: 'received', id: 6, name: this.$filter('translate')('SEGMENTATION:STATISTIC_TYPE:RECEIVED')},
        ]
    }

    isSMS(dispatcherId) {
        for (let i = 0; i < this.dispatchers.length; i++) {
            let dispatcher = this.dispatchers[i];
            if (dispatcherId === dispatcher.id && dispatcher.message_type_id === 2) {
                return true;
            }
        }
    }

    getDispatcherName(selectedDispatcher) {
        if (!selectedDispatcher) return '...';
        if (typeof selectedDispatcher === 'string') return selectedDispatcher;
        if (typeof selectedDispatcher === 'number') return this.getDispatcherNameById(selectedDispatcher);
        return selectedDispatcher.name || '...';
    }

    getDispatcherNameById(dispatcherId) {
        let dispatcher = this.dispatchers.find(dispatcher => dispatcher.id === dispatcherId);
        return dispatcher.name;
    }

    getAllGroups() {
        this.dispatcher_types = this.dispatcher_types ? this.dispatcher_types : [];
        this.subscriberGroups = this.subscriberGroups ? this.subscriberGroups : [];
        this.groups = this.groups ? this.groups : [];
        const groups = this.groups.filter((groupsItem) => groupsItem.fieldType !== 'json');
        return this.subscriberGroups.concat(this.dispatcher_types, groups);
    }

    transformRule(ruleTypeModel) {
        if (this.isStandardField(ruleTypeModel)) return this.transformIntoStandardRule(ruleTypeModel);
        if (this.isCustomField(ruleTypeModel)) return this.transformIntoIntoCustomRule(ruleTypeModel);
        if (this.isSendOut(ruleTypeModel)) return this.transformIntoStatisticRule(ruleTypeModel);
        if (this.isSuppression(ruleTypeModel)) return this.transformIntoSuppressionRule(ruleTypeModel);
    }

    transformIntoStandardRule(ruleTypeModel) {
        this.$scope.rule.rule_type = "standard_rule";
        this.$scope.rule.field = ruleTypeModel.fieldId;
        this.$scope.rule.operator = null;
        this.$timeout( () => this.$scope.rule.value = '' ); // proper value reset
        delete this.$scope.rule.statistic_type;
    }

    transformIntoSuppressionRule(ruleTypeModel) {
        this.$scope.rule.rule_type = "suppression_rule";
        this.$scope.rule.field = ruleTypeModel.fieldId;
        this.$scope.rule.operator = null;
    }

    transformIntoIntoCustomRule(ruleTypeModel) {
        this.$scope.rule.rule_type = "custom_rule";
        this.$scope.rule.field = ruleTypeModel.fieldId;
        this.$scope.rule.operator = null;
        this.$timeout( () => this.$scope.rule.value = '' ); // proper value reset
        delete this.$scope.rule.statistic_type;
    }

    transformIntoStatisticRule(ruleTypeModel) {
        if (this.$scope.rule.rule_type === 'statistic_rule') {
            this.onDispatcherTypeChange(ruleTypeModel);
            return this.updateStatisticTypes();
        }

        this.$scope.rule.rule_type = "statistic_rule";
        this.$scope.rule.operator = null;
        this.$scope.rule.statistic_type = null;
        this.$scope.rule.value = {
            days_limit: this.defaultDaysLimit,
            dispatcher: null,
            dispatcher_type: ruleTypeModel.id,
            last_dispatchers_count: null,
            link: null
        };
        delete this.$scope.rule.field;

        this.onDispatcherTypeChange(ruleTypeModel);
        this.updateStatisticTypes();
    }

    isStandardField(ruleTypeModel) {
        return ruleTypeModel.basedOn === 'standard_field';
    }

    isCustomField(ruleTypeModel) {
        return ruleTypeModel.basedOn === 'custom_field';
    }

    isSendOut(ruleTypeModel) {
        return ruleTypeModel.basedOn === 'send_outs';
    }

    isSuppression(ruleTypeModel) {
        return ruleTypeModel.basedOn === 'suppression';
    }

    removeRule() {
        this.$scope.rulesList.splice(this.$scope.rulesList.indexOf(this.$scope.rule), 1);
    }

    getDispatchersList(search) {
        let initialArray = [];

        if (!search || !search.length) {
            initialArray = [...this.dispatchers];
        } else {
            initialArray = this.dispatchers.filter((dispatcher) => {
                return dispatcher.id === this.$scope.rule.value.dispatcher || dispatcher.name.toLowerCase().indexOf(search.toLowerCase()) !== -1;
            });
        }
        return initialArray.splice(0, this.dispatchersListLength);
    }

    scrolled() {
        if (this.dispatchersListLength < this.dispatchers.length) {
            this.dispatchersListLength += this.dispatcherLoadlistIncrement;
            this.$scope.$apply();
        }
    };

    searched() {
        this.dispatchersListLength = this.initialDispatcherListLength;
    }

    closed() {
        this.$timeout(() => {
            this.dispatchersListLength = this.initialDispatcherListLength;
            this.$scope.$apply();
        }, 10);
    }

    updateLastSelection() {
        this.lastSelection = this.$scope.rule.field || this.$scope.rule.value.dispatcher_type;
    }
}

RuleController.$inject = ['$scope', '$element', '$filter', 'Segment', '$timeout'];
